import { mySupportersQuery } from "@/api/me";
import { queryClient } from "@/api/utils";
import { Outlet, createFileRoute, notFound } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_app/resources")({
  component: Outlet,
  beforeLoad: async () => {
    const supporterData = await queryClient.ensureQueryData(mySupportersQuery());
    const supporters = supporterData?.supporters ?? [];

    if (!supporters.length) {
      throw notFound();
    }
  },
});
